import { z } from "zod";
/** AR-001 — named external builder id (leaf module to avoid circular init). */
export const NamedExternalArtifactBuilderIdV1Schema = z
    .string()
    .min(1)
    .max(80)
    .regex(/^[a-z][a-z0-9_]*$/);
//# sourceMappingURL=artifact-registry-ids.js.map